import React from 'react';
import EyebrowPill from './EyebrowPill';
import { BUSINESS } from '@/lib/businessConfig';

const BOOKING_URL = 'https://www.fresha.com/a/ikonomakis-hair-atelier-halandri-irakleitoy-80-bxynmijf?pId=770996';

// ─── α) Ενότητα «Κομμωτήριο στο Χαλάνδρι» ───────────────────────────────────
function AboutChalandriSection() {
  return (
    <section aria-labelledby="chalandri-salon-heading" className="px-[6vw] py-[90px] bg-cream border-b border-brown/10">
      <div className="max-w-editorial mx-auto">
        <EyebrowPill variant="dark" className="mb-6">Κομμωτήριο Χαλάνδρι από το 1995</EyebrowPill>
        <h2 id="chalandri-salon-heading" className="font-serif text-display-s text-warm-black font-medium leading-[1.05] tracking-[-1.5px] mb-6">
          Κομμωτήριο στο Χαλάνδρι —<br />
          <em className="italic text-gold">30 χρόνια δεύτερης γενιάς.</em>
        </h2>
        <div className="space-y-4 text-body-l text-muted leading-[1.75] max-w-reading">
          <p>
            Το <strong className="text-warm-black">Ikonomakis Hair Atelier</strong> είναι premium κομμωτήριο στο Χαλάνδρι, 
            στη διεύθυνση <strong className="text-warm-black">Ηρακλείτου 80, Χαλάνδρι 15238</strong>. 
            Από το 1995, εξυπηρετούμε πελάτες από την περιοχή και ολόκληρη την Αθήνα — με τη συνέπεια 
            και το επίπεδο που χτίζονται σε <strong className="text-warm-black">30+ χρόνια καθημερινής πρακτικής</strong>.
          </p>
          <p>
            Ο ιδρυτής <strong className="text-warm-black">Θοδωρής Οικονομάκης</strong>, δεύτερη γενιά κομμωτής, 
            εκπαιδεύτηκε και εκπαίδευσε επαγγελματίες κομμωτές σε <strong className="text-warm-black">19 χώρες</strong>. 
            Η φιλοσοφία του atelier: κάθε υπηρεσία ξεκινά με επαγγελματική διάγνωση — <strong className="text-warm-black">προσωπομετρία</strong> για τις αναλογίες και <a href="/prosopologia-visagisme" className="text-gold underline underline-offset-2">προσωπολογία (visagisme)</a> για το τι σας εκφράζει 
            — ποτέ δεν αρχίζουμε χωρίς να καταλάβουμε τι χρειάζεσαι πραγματικά.
          </p>
          <p>
            Εξυπηρετούμε κυρίως πελάτες από: <strong className="text-warm-black">Χαλάνδρι, Βριλήσσια, Μαρούσι, 
            Αγία Παρασκευή, Ψυχικό, Φιλοθέη, Χολαργό, Παπάγου, Νέο Ψυχικό και Κηφισιά</strong>. 
            Αρκετοί επιλέγουν να ταξιδέψουν από ακόμα πιο μακριά — γιατί το αποτέλεσμα αξίζει.{' '}
            <a href="/kommotirio-chalandri" className="text-gold underline underline-offset-2 hover:text-gold-dark transition-colors font-medium">Μάθε περισσότερα για το κομμωτήριο Χαλάνδρι →</a>
          </p>
          <p>
            Αξιολόγηση <strong className="text-warm-black">{BUSINESS.reviews.summaryEl}</strong> στο Fresha. 
            Ραντεβού αποκλειστικά κατόπιν κράτησης — online ή τηλεφωνικά στο <a href="tel:+302118004132" className="text-gold underline underline-offset-2 hover:text-gold-dark transition-colors">211 800 4132</a>.
          </p>
        </div>
      </div>
    </section>
  );
}

// ─── β) Πίνακας σύγκρισης τεχνικών χρώματος ─────────────────────────────────
const COLOR_COMPARISON = [
  {
    technique: 'Balayage',
    href: '/balayage-chalandri',
    suited: 'Όλοι οι τύποι μαλλιών — ιδανικό για φυσικό αποτέλεσμα',
    duration: '2.5–4 ώρες',
    maintenance: 'Κάθε 4–6 μήνες',
    priceFrom: '€150',
  },
  {
    technique: 'Airtouch',
    href: '/services/airtouch',
    suited: 'Πυκνά & σκούρα μαλλιά — εξαιρετικά αδιόρατο gradient',
    duration: '3–5 ώρες',
    maintenance: 'Κάθε 5–7 μήνες',
    priceFrom: '€200',
  },
  {
    technique: 'Babylights',
    href: '/services/babylights',
    suited: 'Ξανθά & ανοιχτά καστανά — λεπτές, φυσικές ανταύγειες',
    duration: '2–3.5 ώρες',
    maintenance: 'Κάθε 3–4 μήνες',
    priceFrom: '€150',
  },
  {
    technique: 'Highlights',
    href: '/hair-color-chalandri',
    suited: 'Όσοι θέλουν πιο έντονη αντίθεση & εμφανή ανταύγειες',
    duration: '1.5–3 ώρες',
    maintenance: 'Κάθε 2–3 μήνες',
    priceFrom: '€80',
  },
];

function ColorComparisonSection() {
  return (
    <section aria-labelledby="color-comparison-heading" className="px-[6vw] py-[90px]">
      <div className="max-w-container-narrow mx-auto">
        <EyebrowPill variant="dark" className="mb-6">Balayage Χαλάνδρι — Σύγκριση Τεχνικών</EyebrowPill>
        <h2 id="color-comparison-heading" className="font-serif text-display-s text-warm-black font-medium leading-[1.05] tracking-[-1.5px] mb-4">
          Balayage, Airtouch, Babylights —<br />
          <em className="italic text-gold">ποια τεχνική σου ταιριάζει;</em>
        </h2>
        <p className="text-body-l text-muted mb-10 max-w-reading leading-[1.7]">
          Κάθε τεχνική χρωματισμού έχει διαφορετικό αποτέλεσμα, κόστος συντήρησης και ιδανικό τύπο μαλλιών. 
          Ο συγκριτικός πίνακας βοηθά στη σωστή επιλογή — πάντα με τελική γνώμη από τον ειδικό σου.
        </p>
        <div className="overflow-x-auto rounded-card border border-brown/15">
          <table className="w-full text-body-s text-warm-black border-collapse">
            <thead>
              <tr className="bg-warm-black text-cream">
                <th className="text-left px-5 py-4 font-semibold tracking-wide text-tiny uppercase">Τεχνική</th>
                <th className="text-left px-5 py-4 font-semibold tracking-wide text-tiny uppercase">Σε ποιον ταιριάζει</th>
                <th className="text-left px-5 py-4 font-semibold tracking-wide text-tiny uppercase hidden sm:table-cell">Διάρκεια</th>
                <th className="text-left px-5 py-4 font-semibold tracking-wide text-tiny uppercase hidden md:table-cell">Συντήρηση</th>
                <th className="text-right px-5 py-4 font-semibold tracking-wide text-tiny uppercase">Τιμή από</th>
              </tr>
            </thead>
            <tbody>
              {COLOR_COMPARISON.map((row, i) => (
                <tr key={row.technique} className={i % 2 === 0 ? 'bg-cream-bg' : 'bg-cream'}>
                  <td className="px-5 py-4 font-serif font-medium text-[16px]">
                    <a href={row.href} className="text-gold hover:text-gold-dark underline underline-offset-2 transition-colors">
                      {row.technique}
                    </a>
                  </td>
                  <td className="px-5 py-4 text-muted leading-snug">{row.suited}</td>
                  <td className="px-5 py-4 text-muted hidden sm:table-cell">{row.duration}</td>
                  <td className="px-5 py-4 text-muted hidden md:table-cell">{row.maintenance}</td>
                  <td className="px-5 py-4 text-right font-semibold text-warm-black">{row.priceFrom}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="text-tiny text-muted mt-4">* Τιμές «από» για Hair Stylist / Colorist tier. Color Expert tier: +30–50% · Master tier: +70–85%. Τελική τιμή κατόπιν διάγνωσης.</p>
      </div>
    </section>
  );
}

// ─── γ) Κριτικές: ΜΟΝΟ στο carousel της αρχικής (αυθεντικά κείμενα Fresha) — ένα block, όχι τρία ──

// ─── δ) Face Metrics Pro ──────────────────────────────────────────────────────
function FaceMetricsSection() {
  return (
    <section aria-labelledby="face-metrics-heading" className="px-[6vw] py-[90px]">
      <div className="max-w-editorial mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-10 items-start">
          <div>
            <EyebrowPill variant="dark" className="mb-6">Πρώτο στην Ελλάδα · AI Ανάλυση Προσώπου</EyebrowPill>
            <h2 id="face-metrics-heading" className="font-serif text-display-s text-warm-black font-medium leading-[1.05] tracking-[-1.5px] mb-5">
              Face Metrics Pro —<br />
              <em className="italic text-gold">η επιστήμη πίσω από το ιδανικό κούρεμα.</em>
            </h2>
            <div className="space-y-4 text-body-l text-muted leading-[1.75] max-w-reading">
              <p>
                Το <strong className="text-warm-black">Face Metrics Pro</strong> είναι η πρωτοποριακή μέθοδος μορφολογικής 
                ανάλυσης προσώπου που δημιούργησε ο Θοδωρής Οικονομάκης — 
                <strong className="text-warm-black"> το πρώτο κομμωτήριο στην Ελλάδα</strong> που εντάσσει 
                επιστημονική προσωπομετρία στη διαδικασία consultation.
              </p>
              <p>
                Μέσα σε <strong className="text-warm-black">45 λεπτά</strong>, αναλύονται η γεωμετρία, οι αναλογίες 
                και η συμμετρία του προσώπου σου για να σου δοθεί τεκμηριωμένη πρόταση: 
                ποιο κούρεμα, ποια τεχνική χρώματος και ποιο styling σε "εξισορροπεί" οπτικά — 
                με βάση επιστημονικά κριτήρια, όχι εμπειρικές εκτιμήσεις.
              </p>
              <p>
                Ιδανικό για νέους πελάτες, πριν από σημαντική αλλαγή look, ή σαν <em>premium gift</em> για κάποιον αγαπημένο σου.
              </p>
            </div>
            <div className="mt-8 flex flex-wrap gap-4 items-center">
              <a
                href="/services/face-metrics-pro"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-pill bg-gold text-cream text-body-s font-semibold hover:bg-gold-dark transition-colors"
              >
                Μάθε περισσότερα →
              </a>
              <div className="flex items-center gap-3 px-5 py-3 rounded-pill bg-cream-soft border border-brown/15">
                <span className="text-gold text-lg">✦</span>
                <span className="text-body-s font-semibold text-warm-black">€100 · 45 λεπτά</span>
              </div>
            </div>
          </div>
          <div className="hidden lg:flex flex-col gap-3 min-w-[220px]">
            {[
              { label: 'Ανάλυση γεωμετρίας', icon: '📐' },
              { label: 'Αναλογίες προσώπου', icon: '📏' },
              { label: 'Bespoke πρόταση χρώματος', icon: '🎨' },
              { label: 'Ιδανικό κούρεμα', icon: '✂️' },
              { label: 'Styling συστάσεις', icon: '✦' },
            ].map((f) => (
              <div key={f.label} className="flex items-center gap-3 px-4 py-3 rounded-card-sm bg-cream-soft border border-brown/10">
                <span className="text-lg">{f.icon}</span>
                <span className="text-body-s font-medium text-warm-black">{f.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── ε) Τιμοκατάλογος ────────────────────────────────────────────────────────
const PRICE_LIST = [
  { service: 'Γυναικείο Κούρεμα', priceFrom: '€45', href: '/womens-haircut-chalandri', note: 'Hair Stylist' },
  { service: 'Ανδρικό Κούρεμα', priceFrom: '€43', href: '/antriko-kourema-chalandri', note: '' },
  { service: 'Balayage', priceFrom: '€150', href: '/balayage-chalandri', note: 'Hand-painted' },
  { service: 'Airtouch', priceFrom: '€200', href: '/services/airtouch', note: 'Gradient technique' },
  { service: 'Babylights', priceFrom: '€150', href: '/services/babylights', note: 'Λεπτές ανταύγειες' },
  { service: 'Βαφή (Hair Color)', priceFrom: '€43', href: '/hair-color-chalandri', note: '' },
  { service: 'Κερατίνη', priceFrom: '€150', href: '/keratin-treatment-chalandri', note: 'Qiqi Vega' },
  { service: 'K18 Hair Treatment', priceFrom: '€45', href: '/k18-hair-treatment-chalandri', note: 'Molecular repair' },
  { service: 'Milbon 360°', priceFrom: '€195', href: '/milbon-360-chalandri', note: 'Ιαπωνική τεχνολογία' },
  { service: 'Face Metrics Pro', priceFrom: '€100', href: '/services/face-metrics-pro', note: 'AI ανάλυση προσώπου' },
];

function PriceListSection() {
  return (
    <section aria-labelledby="pricelist-heading" className="px-[6vw] py-[90px] bg-cream">
      <div className="max-w-container-narrow mx-auto">
        <EyebrowPill variant="dark" className="mb-6">Τιμές Κομμωτηρίου Χαλάνδρι</EyebrowPill>
        <h2 id="pricelist-heading" className="font-serif text-display-s text-warm-black font-medium leading-[1.05] tracking-[-1.5px] mb-4">
          Τιμοκατάλογος υπηρεσιών —<br />
          <em className="italic text-gold">διαφάνεια πριν από κάθε ραντεβού.</em>
        </h2>
        <p className="text-body-l text-muted mb-10 max-w-reading leading-[1.7]">
          Οι τιμές που αναφέρονται είναι τιμές «από» για Hair Stylist / Colorist tier. 
          Η τελική τιμή εξαρτάται από το tier του ειδικού, το μήκος μαλλιών και την υπηρεσία που θα επιλέξεις κατά τη διάγνωση.
        </p>
        <div className="rounded-card border border-brown/15 overflow-hidden">
          <table className="w-full text-body-s border-collapse">
            <thead>
              <tr className="bg-warm-black text-cream">
                <th className="text-left px-5 py-4 font-semibold tracking-wide text-tiny uppercase">Υπηρεσία</th>
                <th className="text-left px-5 py-4 font-semibold tracking-wide text-tiny uppercase hidden sm:table-cell">Σημείωση</th>
                <th className="text-right px-5 py-4 font-semibold tracking-wide text-tiny uppercase">Τιμή από</th>
              </tr>
            </thead>
            <tbody>
              {PRICE_LIST.map((row, i) => (
                <tr key={row.service} className={i % 2 === 0 ? 'bg-cream-bg hover:bg-cream-soft' : 'bg-cream hover:bg-cream-soft'} style={{ transition: 'background 0.15s' }}>
                  <td className="px-5 py-4 font-medium">
                    <a href={row.href} className="text-warm-black hover:text-gold transition-colors underline-offset-2 hover:underline">
                      {row.service}
                    </a>
                  </td>
                  <td className="px-5 py-4 text-muted hidden sm:table-cell">{row.note}</td>
                  <td className="px-5 py-4 text-right font-serif font-semibold text-[17px] text-gold">{row.priceFrom}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="text-tiny text-muted mt-4">
          * Color Expert tier: +30–50% · Master tier: +70–85% · Τιμές για μαλλιά μέχρι ώμους. Κλείσε{' '}
          <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="text-gold underline underline-offset-2 hover:text-gold-dark transition-colors">ραντεβού online</a>{' '}
          ή κάλεσέ μας στο <a href="tel:+302118004132" className="text-gold underline underline-offset-2 hover:text-gold-dark transition-colors">211 800 4132</a>.
        </p>
      </div>
    </section>
  );
}

// ─── Κύριο export: συνδυάζει όλες τις ενότητες ───────────────────────────────
export default function HomeSEOSections() {
  return (
    <>
      <AboutChalandriSection />
      <ColorComparisonSection />
      <FaceMetricsSection />
      <PriceListSection />
    </>
  );
}